import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/quality-assurance/qms-setup")({
  beforeLoad: () => { throw redirect({ to: "/en/services/quality-assurance/qms-development-optimization", statusCode: 301 }); },
});
